import React, { useEffect, useState } from "react";
import { Box, Button, IconButton } from "@mui/material";
import { DataGrid, GridColDef, ptBR } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import { ZoomIn } from "@mui/icons-material";
import { getSpeakerAll } from "../../../Services/Speaker";
import { TextH2 } from "../../../styles/global.styles";
import { ImgSgv } from "../../Login/stylesLogin";

export const Speaker = () => {
  const navigate = useNavigate();
  const [speakers, setSpeakers] = useState<any[]>([]);
  const [pageSize, setPageSize] = useState(20);
  const [isLoading, setIsLoading] = useState(false);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 20,
  });

  useEffect(() => {
    setIsLoading(true);
    getSpeakerAll(
      paginationModel.page * paginationModel.pageSize,
      paginationModel.pageSize
    ).then((response: any) => {
      setIsLoading(false);
      const data = response?.data;
      if (data) {
        setPageSize(data.pagination?.[0]?.total || 20);
        setSpeakers(data.data || []);
      }
    });
  }, [paginationModel]);

  const columns: GridColDef[] = [
    { field: "name", headerName: "Nome", minWidth: 200 },
    { field: "jobRole", headerName: "Cargo", minWidth: 200 },
    { field: "description", headerName: "Descrição", minWidth: 400, flex: 2 },
    { field: "linkedinUrl", headerName: "LinkedIn", minWidth: 200 },
    {
      field: "actions",
      headerName: "Ações",
      minWidth: 120,
      renderCell: (params) => (
        <Box display={"flex"} gap={2}>
          <IconButton aria-label="detalhes" onClick={() => navigate(`/speaker/${params.row.id}`)}>
            <ZoomIn />
          </IconButton>
        </Box>
      ),
    },
  ];

  return (
    <>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <TextH2 style={{ display: "flex", alignItems: "center" }}>
          <ImgSgv width={24} src="/icons/menu/visao.svg" />
          &nbsp;Palestrantes
        </TextH2>
        <Button
          variant="contained"
          style={{ backgroundColor: "#9c9b9f", color: "#fff", fontWeight: "bold", borderRadius: 10, height: 56, width: 160}}
          onClick={() => navigate("/speaker/New")}
        >
          <ImgSgv style={{ marginRight: 5, marginLeft: 10 }} width={18} src="/icons/menu/new.svg" />
          Cadastrar
        </Button>
      </div>
      <br />
      <Box sx={{ height: "90%", width: "100%" }}>
        <DataGrid
          localeText={ptBR.components.MuiDataGrid.defaultProps.localeText}
          rows={speakers}
          columns={columns}
          rowCount={pageSize}
          loading={isLoading}
          pageSizeOptions={[20, 50, 100]}
          paginationModel={paginationModel}
          paginationMode="server"
          onPaginationModelChange={setPaginationModel}
        />
      </Box>
    </>
  );
};

export default Speaker;
